<template>
	<div class="form-background max-width-750 pd-bottom-lg">
		<Form
		:model="formState"
		name="basic"
		:label-col="{ span: 8 }"
		:wrapper-col="{ span: 16 }"
		:colon="false"
		autocomplete="off"
		>
			<FormItem>
				<TypographyTitle :level="3">{{ $t('rover-page.roverPasswordHeader') }}</TypographyTitle>
			</FormItem>
			<FormItem
				:label="$t('rover-page.fields.newPassword')"
				v-bind="validateInfos.password"
			>
				<Input v-model:value="formState.password" @keyup.enter="onSubmit"/>
			</FormItem>

			<FormItem :wrapper-col="{ xs: { span: 24 }, sm: { offset: 8, span: 16 } }">
				<Button
					type="primary"
					@click.prevent="onSubmit"
					:disabled="isSubmitting"
					:loading="isSubmitting"
				>
					{{ $t('rover-page.updateButtonLabel') }}
				</Button>
			</FormItem>
		</Form>
	</div>
</template>

<script>
import { reactive, toRef } from 'vue';
import { TypographyTitle, Button, Form, FormItem, Input } from 'ant-design-vue';

import { useI18n } from 'vue-i18n'

import Api from '@/api/Api';

import { useRoverForm } from '@/components/rovers/useRoverForm';

export default {
	components: {
		TypographyTitle, Button, Form, FormItem, Input,
	},
	props: ['roverId'],
	setup(props) {
		const { t } = useI18n();
		const formState = reactive({
			password: '',
		});
		const rulesRef = reactive({
			password: [{ required: true, message: t('rover-page.messages.enterPassword') }],
		});
		const roverIdRef = toRef(props, 'roverId');
		const {
			validateInfos,
			isSubmitting,
			onSubmit,
		} = useRoverForm(formState, rulesRef, roverIdRef, Api.roverUpdatePassword);

		return {
			formState,
			validateInfos,
			isSubmitting,
			onSubmit,
		};
	},
}
</script>
